import { Card, Typography } from "@mui/material";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { motion } from "motion/react";
import { Icon } from "@iconify/react";
import "./ContactMeCard.css";
import me2 from "../../assets/img/me_2.jpg";

const ContactMeCard = (props) => {
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const isTabletOrMobile2 = useMediaQuery({ query: "(max-width: 600px)" });

  const onClickFacebookIcon = () => {
    window.open("https://web.facebook.com/thushaltk/");
  };

  const onClickInstagramIcon = () => {
    window.open("https://www.instagram.com/thuzhaltk/");
  };

  const onClickLinkedInIcon = () => {
    window.open("https://www.linkedin.com/in/thushaltk/");
  };

  const onClickGithubIcon = () => {
    window.open("https://github.com/thushaltk");
  };

  return (
    <>
      <Card
        style={{
          width: isTabletOrMobile ? "100%" : "75%",
          height: "fit-content",
          display: isTabletOrMobile ? "" : "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "15px",
          boxShadow: "5px 5px 10px #888888",
        }}
      >
        <div
          style={{
            width: isTabletOrMobile ? "100%" : "40%",
            height: "100%",
          }}
        >
          <img
            src={me2}
            style={{
              width: "100%",
              borderRadius: isTabletOrMobile ? "" : "35px",
            }}
          />
        </div>
        <div
          style={{
            width: isTabletOrMobile ? "100%" : "60%",
            height: "100%",
            padding: isTabletOrMobile ? "20px" : "30px",
          }}
        >
          <div
            style={{
              width: "100%",
              height: "40%",
            }}
          >
            <Typography
              style={{
                fontSize: isTabletOrMobile ? "30px" : "36px",
                fontFamily: "Tenorite",
                fontWeight: "700",
              }}
            >
              <span
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
              >
                THUSHAL THARAKA KULATILAKE
              </span>
            </Typography>
            <Typography
              style={{
                fontSize: "12px",
                fontFamily: "Tenorite",
              }}
            >
              <span
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
              >
                BSc (Hons) in Information Technology specialized in Software
                Engineering (SLIIT)
              </span>
            </Typography>
            <Typography
              style={{
                fontSize: "12px",
                fontFamily: "Tenorite",
                marginTop: "5px",
              }}
            >
              <span
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
              >
                Bachelors in Information Communication Technology (Hons)
                specialized in Games and Animation Development (University of
                Kelaniya)
              </span>
            </Typography>
          </div>
          <div
            style={{
              width: "100%",
              height: "40%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: "25px",
            }}
          >
            <Card id="card">
              <Typography
                style={{
                  fontSize: "15px",
                  fontFamily: "Tenorite",
                  textAlign: "center",
                }}
              >
                <span
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  Email Me
                </span>
              </Typography>
              <Typography
                style={{
                  fontSize: isTabletOrMobile2 ? "10px" : "20px",
                  fontFamily: "Tenorite",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                <span
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  thushal.kulatilake@gmail.com
                </span>
              </Typography>
            </Card>
            <Card id="card">
              <Typography
                style={{
                  fontSize: "15px",
                  fontFamily: "Tenorite",
                  textAlign: "center",
                }}
              >
                <span
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  Contact Number
                </span>
              </Typography>
              <Typography
                style={{
                  fontSize: "20px",
                  fontFamily: "Tenorite",
                  fontWeight: "700",
                  textAlign: "center",
                }}
              >
                <span
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  +94764464488
                </span>
              </Typography>
            </Card>
            <Card id="card">
              <Typography
                style={{
                  fontSize: "15px",
                  fontFamily: "Tenorite",
                  textAlign: "center",
                }}
              >
                <span
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  My Socials
                </span>
              </Typography>
              <div
                style={{
                  height: "30px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  <Icon
                    onClick={onClickFacebookIcon}
                    id="socials"
                    icon="logos:facebook"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  <Icon
                    onClick={onClickInstagramIcon}
                    id="socials"
                    icon="skill-icons:instagram"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  <Icon
                    onClick={onClickLinkedInIcon}
                    id="socials"
                    icon="skill-icons:linkedin"
                  />
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, scale: 0 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                >
                  <Icon
                    onClick={onClickGithubIcon}
                    id="socials"
                    icon="devicon:github"
                    style={{ marginRight: "0px" }}
                  />
                </motion.div>
              </div>
            </Card>
          </div>
        </div>
      </Card>
    </>
  );
};

export default ContactMeCard;
